module.exports = __webpack_public_path__ + "static/moscow-ea58a0acd42c88579724abdd93e69b32.png";